module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/431fd7ca74b8eb8ed49519771b2334e6.png";